import { createContext, useContext } from "react";

const PortalContext = createContext("/tenant");

export const PortalProvider = PortalContext.Provider;
export const usePortalBase = () => useContext(PortalContext);
